import React from 'react';
import { Navigate } from 'react-router-dom';
import useSessionStorageService from './services/session';
import { resolvePathWithSavedParams } from './services/resolvePathWithSavedParams';

export default function NRNavigateRedirect({ to, replace = true }) {
  const { getSessionKeyData } = useSessionStorageService();
  const finalPath = resolvePathWithSavedParams(to, getSessionKeyData);

  return <Navigate to={finalPath} replace={replace} />;
}
